import { useState } from 'react';
import { useAuth } from '../hooks/useAuth.js';

// Standalone sign-in page: the invite flow's fallback target and the only
// mobile sign-in entry (the sidebar footer form is desktop-only). Shares
// the one sign-in code path in useAuth.
export default function SignInPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error: err } = await signIn(email, password);
    setBusy(false);
    if (err) { setError(err.message); return; }
    window.location.href = '/';
  };

  return (
    <div className="auth-page">
      <div className="auth-page__card">
        <h1 className="auth-page__title">Mike's GWS Map</h1>
        <p className="auth-page__sub">Sign in to edit vineyard data</p>
        <form onSubmit={handleSubmit} className="auth-page__form">
          <label className="auth-page__field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@example.com"
              autoFocus
              required
            />
          </label>
          <label className="auth-page__field">
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <p className="auth-page__error">{error}</p>}
          <button type="submit" className="btn btn--primary" style={{ width: '100%' }} disabled={busy}>
            {busy ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <a href="/" className="auth-page__link">← Back to map</a>
      </div>
    </div>
  );
}
